import React from "react";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { Form } from "../../../../components/SkyFramework/Forms";
import { ButtonBack } from "../../../../components/SkyFramework/ProgressTab/ButtonBack";

// Constants
const phrasebook = phrasebookLoad();

export default class AddPortingNumbers extends React.Component {
  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  //

  render() {
    const { uploadFile, downloadFile, loggedAccount, saveChanges, handleChange, nextStep, prevStep, actualState } = this.props;
    if (actualState.number_quantity) {
      let inputs = [
        { type: "infoalert", value: phrasebook.tooltip.porting_number_req },
        { label: phrasebook.orders.porting_req, type: "textarea", id: "porting_number_to", name: 'porting_number_to', value: actualState.porting_number_to, disabled: loggedAccount < 200 ? true : false },
      ];

      if (loggedAccount < 200) {
        if (!actualState.porting_number_to_file) {
          inputs.push({ label: phrasebook.orders.porting_req_file, type: "info", value: phrasebook.common.file_not_uploaded });
        } else {
          inputs.push({ label: phrasebook.orders.porting_req_file, type: "download", id: "porting_number_to_file", name: 'requirement', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel', value: actualState.porting_number_to_file })
        }
      } else {
        inputs.push({ label: phrasebook.orders.porting_req_file, type: "file", id: "porting_number_to_file", name: 'requirement', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })
        inputs.push({ label: phrasebook.common.uploaded_file, type: "info", value: actualState.porting_number_to_file });
      }
      const buttons = [<ButtonBack title={phrasebook.common.previous} prevStep={prevStep} />, <button className="btn btn-main btn-xxs-block" onClick={saveChanges}>{phrasebook.common.save}</button>, <ButtonBack title={phrasebook.common.next} prevStep={nextStep} />]

      return (<Form
        handleSubmit={undefined}
        uploadFile={uploadFile}
        downloadFile={downloadFile}
        onChange={handleChange}
        title={phrasebook.orders.add_porting_required}
        inputs={inputs}
        buttons={buttons}
      />
      );
    } else return null


  }
}
